<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <Aguarde :show="httpAguarde"></Aguarde>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="mt-1 mb-3">Lista de DUAMs Emitidas</h5>
            <div class="row border-bottom mb-3">
              <div class="col-12">
                <b-form @submit.prevent="listDuams">
                  <div class="row">
                    <div class="col-md-6">
                      <b-form-group
                          label="Nome/Razão Social"
                          label-for="pes_nome">
                        <input
                            id="pes_nome"
                            v-model="filtro.pes_nome"
                            type="text"
                            maxlength="20"
                            class="form-control"
                            placeholder=" ">
                      </b-form-group>
                    </div>
                    <div class="col-md-6">
                      <b-form-group
                          label="Nome Fantasia"
                          label-for="eco_nome_fantasia">
                        <input
                            id="eco_nome_fantasia"
                            v-model="filtro.eco_nome_fantasia"
                            type="text"
                            maxlength="20"
                            class="form-control"
                            placeholder=" ">
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <b-form-group
                          label="CPF/CNPJ">
                        <the-mask class="form-control" v-model="filtro.pes_cpfcnpj"
                                  :mask="['###.###.###-##', '##.###.###/####-##']"/>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                          label="Código da DUAM"
                          label-for="dam_codigo">
                        <input
                            id="dam_codigo"
                            v-model="filtro.dam_codigo"
                            type="text"
                            maxlength="20"
                            class="form-control"
                            placeholder=" ">
                      </b-form-group>
                    </div>
                    <div class="col-md-4">
                      <b-form-group label="Status da DUAM" label-for="tab_106situacao">
                        <select id="tab_106situacao"
                                v-model="filtro.tab_106situacao"
                                @change="listDuams()"
                                class="custom-select" type="text">
                          <option value="">Todas DUAMs em aberto</option>
                          <option value="963">Aberta</option>
                          <option value="964">Aguardando pagamento - sob demanda</option>
                          <option value="965">Inscrita Divida Ativa</option>
                          <option value="966">Parcelada</option>
                          <option value="967">Estorno para Repactuação</option>
                          <option value="968">Suspensão Ato Administrativo</option>
                          <option value="969">Suspensão Decisão Judicial</option>
                          <option value="970">Cancelado</option>
                          <option value="971">Prescrita</option>
                          <option value="972">Estimativa Simples Nacional</option>
                          <option value="973">Isento</option>
                          <option value="974">Imune</option>
                          <option value="975">Pagamento Parcial</option>
                          <option value="976">Pagamento Total</option>
                        </select>
                      </b-form-group>
                    </div>
                    <div class="col-md-2 text-right">
                      <b-form-group
                          label="'"
                          class="text-white">
                        <button type="submit"
                                class="btn btn-label btn-primary"><i
                            class="bx bx-search label-icon"></i>
                          Pesquisar
                        </button>
                      </b-form-group>
                    </div>
                  </div>
                </b-form>
              </div>
            </div>
            <Loader :loading="httpSend">
            <div v-show="!list_duam.length || list_duam.length < 1" role="alert" aria-live="polite"
                 aria-atomic="true" class="alert alert-primary text-center">
              Sem DUAMs
            </div>
            <div v-for="g in list_duam" :key="g.dam_codigo" class="row">
              <div class="col-md-12 mb-3 border-bottom">
                <div class="row">
                  <div class="col-md-3">
                    <b-form-group label="CPF/CNPJ">
                      <h6 v-if="g.pes_cpfcnpj.length < 12" class="mb-0">
                        {{ g.pes_cpfcnpj | VMask('###.###.###-##') }}</h6>
                      <h6 v-else class="mb-0">{{ g.pes_cpfcnpj | VMask('##.###.###/####-##') }}</h6>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group label="Nome/Razão Social">
                      <h6 class="mb-0">{{ g.pes_nome }}</h6>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group label="Nome Fantasia">
                      <h6 v-if="g.eco_nome_fantasia" class="mb-0">{{ g.eco_nome_fantasia }}</h6>
                      <h6 v-else class="mb-0">Não Informado</h6>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <b-form-group label="N° da DUAM">
                      <h6 class="mb-0">{{ g.dam_codigo }}</h6>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group label="Competência">
                      <h6 class="mb-0">{{ g.dam_mes_ref }}/{{ g.dam_ano_ref }}</h6>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group label="Situação">
                      <h6 class="mb-0">{{ g.tab_nome }}</h6>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <b-form-group label="Tributo">
                      <h6 class="mb-0">{{ g.tip_nome }}</h6>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Valor">
                      <h6 class="mb-0">{{ g.dut_valortributo | formatNumeroBr }}</h6>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Atualizações">
                      <h6 class="mb-0">{{ g.dut_atualizacao | formatNumeroBr }}</h6>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Juros">
                      <h6 class="mb-0">{{ g.dut_juros | formatNumeroBr }}</h6>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <b-form-group label="Multa">
                      <h6 class="mb-0">{{ g.dut_multa | formatNumeroBr }}</h6>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Desconto">
                      <h6 class="mb-0">{{ g.dut_desconto | formatNumeroBr }}</h6>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Total">
                      <h5 class="mb-0 text-danger">{{ g.dut_valortotal | formatNumeroBr }}</h5>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Vencimento">
                      <h5 class="mb-0 text-danger">
                        {{ g.dam_data_venc_atu | formatDate }}</h5>
                    </b-form-group>
                  </div>
                </div>
                <div v-if="g.pagamento" class="row">
                  <div class="col-md-3">
                    <b-form-group label="Valor Pago">
                      <h5 class="mb-0 text-success font-weight-bold">{{
                          g.pagamento.bab_valor_pago | formatNumeroBr
                        }}</h5>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Data de Pagamento">
                      <h5 class="mb-0 text-success font-weight-bold">
                        {{ g.pagamento.bab_data_pagamento }}</h5>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                  <span v-show="(g.tab_codigo ==='963' || g.tab_codigo ==='964') && !g.pagamento">
                      <button type="button" @click="pagamento(g)"
                              title="Visualizar Guia"
                              class="btn btn-success btn-sm mr-2 mb-2">
                      <i class="bx bx-money"></i> Realizar Pagamento
                      </button>
                      <button type="button" @click="showModalAlterarVencimento(g)"
                              title="Alterar Vencimento"
                              class="btn btn-warning btn-sm mr-2 mb-2">
                      <i class="bx bx-reset"></i> Alterar Vencimento
                      </button>
                    <button type="button" @click="showModalbaixaManual(g)"
                            title="Realizar Baixa Manual da DUAM"
                            class="btn btn-dark btn-sm mr-2 mb-2">
                      <i class="bx bx-downvote"></i> Baixa Manual
                      </button>
                  </span>
                    <button v-show="g.pagamento" type="button" @click="printComprovante(g)"
                            title="Comprovante de Pagamento"
                            class="btn btn-info btn-sm mr-2 mb-2">
                      <i class="bx bx-printer"></i> Comprovante de Pagamento
                    </button>
                    <button type="button" @click="guiaDetalhe(g)" title="Detalhes da DUAM"
                            class="btn btn-outline-secondary btn-sm mr-2 mb-2">
                      <i class="bx bx-show-alt"></i> Detalhes da DUAM
                    </button>
                  </div>
                </div>
              </div>
            </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <modal :height="'auto'" :clickToClose="false" :adaptive="true" :draggable="true" name="modal-baixa-manual">
      <div class="card mb-0">
        <div class="card-body">
          <div class="row">
            <div class="col-md-8">
              <h5 class="mt-1 mb-4">Baixa Manual de DUAM</h5>
            </div>
            <div class="col-md-4 text-right">
              <button type="button" @click="hideModalBaixaManual()" title="Fechar"
                      class="btn btn-outline-dark btn-sm mr-2 mt-0"><i class="bx bx-x"></i> Fechar
              </button>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-4">
                <b-form-group label="N° da DUAM">
                  <h6 class="mb-0">{{ duam_baixa_manual.dam_codigo }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group label="Competência">
                  <h6 class="mb-0">{{ duam_baixa_manual.dam_mes_ref }}/{{ duam_baixa_manual.dam_ano_ref }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group label="Vencimento">
                  <h5 class="mb-0 text-danger">
                    {{ duam_baixa_manual.dam_data_venc_atu | formatDate }}</h5>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div v-if="duam_baixa_manual.pes_cpfcnpj" class="col-md-4">
                <b-form-group label="CPF/CNPJ">
                  <h6 v-if="duam_baixa_manual.pes_cpfcnpj.length < 12" class="mb-0">
                    {{ duam_baixa_manual.pes_cpfcnpj | VMask('###.###.###-##') }}</h6>
                  <h6 v-else class="mb-0">{{ duam_baixa_manual.pes_cpfcnpj | VMask('##.###.###/####-##') }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-8">
                <b-form-group label="Nome/Razão Social">
                  <h6 class="mb-0">{{ duam_baixa_manual.pes_nome }}</h6>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <b-form-group label="Valor">
                  <h6 class="mb-0">{{ duam_baixa_manual.dut_valortributo | formatNumeroBr }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group label="Juros">
                  <h6 class="mb-0">{{ duam_baixa_manual.dut_juros | formatNumeroBr }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Multa">
                  <h6 class="mb-0">{{ duam_baixa_manual.dut_multa | formatNumeroBr }}</h6>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <b-form-group label="Atualizações">
                  <h6 class="mb-0">{{ duam_baixa_manual.dut_atualizacao | formatNumeroBr }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group label="Desconto">
                  <h6 class="mb-0">{{ duam_baixa_manual.dut_desconto | formatNumeroBr }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group label="Total">
                  <h5 class="mb-0 text-danger">{{ duam_baixa_manual.dut_valortotal | formatNumeroBr }}</h5>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <b-form-group
                    label="Data do Crédito"
                    label-for="bab_data_credbanco">
                  <input
                      id="bab_data_credbanco"
                      v-model="duam_baixa_manual.bab_data_credbanco"
                      type="date"
                      class="form-control">
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group
                    label="Valor Pago"
                    label-for="bab_valor_pago">
                  <money class="form-control"
                         id="bab_valor_pago"
                         v-model="duam_baixa_manual.bab_valor_pago"
                         v-bind="money"></money>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group
                    label-class="text-white"
                    label="´">
                  <button type="button" @click="showModalbaixaManualConfirmacao()" title="Detalhes da DUAM"
                          class="btn btn-success btn-sm mr-2 mt-1">
                    <i class="bx bx-check-double"></i> Realizar Baixa
                  </button>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal :height="'auto'" :clickToClose="false" :adaptive="true" name="modal-baixa-manual-confirmacao">
      <div class="card mb-0">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 text-center">
              <h5 class="mt-1 mb-4">Confirma a baixa manual da DUAM?</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 text-right">
              <button type="button" @click="baixaManual()" title="Detalhes da DUAM"
                      class="btn btn-success mr-3 mt-1">
                <i class="bx bx-check-double"></i> SIM
              </button>
            </div>
            <div class="col-md-6 text-left">
              <button type="button" @click="hideModalBaixaManualConfirmacao()" title="Detalhes da DUAM"
                      class="btn btn-dark ml-3 mt-1">
                <i class="bx bx-check-double"></i> NÂO
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal :height="'auto'" :clickToClose="false" :adaptive="true" :draggable="true" name="modal-alterar-vencimento">
      <div class="card mb-0">
        <div class="card-body">
          <div class="row">
            <div class="col-md-8">
              <h5 class="mt-1 mb-4">Alteração de Vencimento</h5>
            </div>
            <div class="col-md-4 text-right">
              <button type="button" @click="hideModalAlterarVencimento()" title="Fechar"
                      class="btn btn-outline-dark btn-sm mr-2 mt-0"><i class="bx bx-x"></i> Fechar
              </button>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-4">
                <b-form-group label="N° da DUAM">
                  <h6 class="mb-0">{{ duam_baixa_manual.dam_codigo }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group label="Competência">
                  <h6 class="mb-0">{{ duam_baixa_manual.dam_mes_ref }}/{{ duam_baixa_manual.dam_ano_ref }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group label="Vencimento">
                  <h5 class="mb-0 text-danger">
                    {{ duam_baixa_manual.dam_data_venc_atu | formatDate }}</h5>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div v-if="duam_baixa_manual.pes_cpfcnpj" class="col-md-4">
                <b-form-group label="CPF/CNPJ">
                  <h6 v-if="duam_baixa_manual.pes_cpfcnpj.length < 12" class="mb-0">
                    {{ duam_baixa_manual.pes_cpfcnpj | VMask('###.###.###-##') }}</h6>
                  <h6 v-else class="mb-0">{{ duam_baixa_manual.pes_cpfcnpj | VMask('##.###.###/####-##') }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-8">
                <b-form-group label="Nome/Razão Social">
                  <h6 class="mb-0">{{ duam_baixa_manual.pes_nome }}</h6>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <b-form-group label="Valor Original">
                  <h6 class="mb-0">{{ duam_baixa_manual.dut_valortributo | formatNumeroBr }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group
                    label="Novo Vencimento"
                    label-for="novo_vencimento">
                  <input
                      id="novo_vencimento"
                      v-model="duam_baixa_manual.novo_vencimento"
                      type="date"
                      class="form-control">
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group
                    label-class="text-white"
                    label="´">
                  <button type="button" @click="realizarAlteracaoVencimento()" title="Realizar Alteração"
                          class="btn btn-success btn-sm mt-1">
                    <i class="bx bx-check-double"></i> Realizar Alteração
                  </button>
                </b-form-group>
              </div>
            </div>
            <!--
            <div v-if="duam_atualizada.dam_codigo">
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Juros">
                    <h6 class="mb-0">{{ duam_atualizada.dut_juros | formatNumeroBr }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Multa">
                    <h6 class="mb-0">{{ duam_atualizada.dut_multa | formatNumeroBr }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Atualizações">
                    <h6 class="mb-0">{{ duam_atualizada.dut_atualizacao | formatNumeroBr }}</h6>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Desconto">
                    <h6 class="mb-0">{{ duam_atualizada.dut_desconto | formatNumeroBr }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Novo Valor Total">
                    <h5 class="mb-0 text-danger">{{ duam_atualizada.dut_valortotal | formatNumeroBr }}</h5>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <button type="button" @click="realizarAlteracaoVencimento()" title="Realizar Alteração"
                          class="btn btn-success btn-sm mt-4">
                    <i class="bx bx-check-double"></i> Realizar Alteração
                  </button>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </modal>
  </Layout>
</template>
<script>
import Layout from "@/router/layouts/main";
import {VMoney, Money} from 'v-money'
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import Aguarde from "@/components/widgets/aguarde";
import Loader from "@/components/widgets/loader";
import {TheMask} from 'vue-the-mask'
import {duamBaixaManual, listDuamsEmitidas} from "@/api/admin/gestao/duams_emitidas";
import {impressao} from "@/helps/impressao";
import {getFinanceiroComprovante, getFinanceiroGuia} from "@/api/relatorio/financeiro";
import {notifyAviso, notifyErro, notifySucesso} from "@/helps/notificacao";
import {alteracaoVencimentoDuam, verificaAlteracaoVencimento} from "@/api/financeiro/pagamento";

export default {
  page: {
    title: "Guias",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Money,
    PageHeader,
    TheMask,
    Aguarde,
    Loader
  },
  directives: {money: VMoney},
  data() {
    return {
      title: "DUAMs Emitidas",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'DUAMs Emitidas',
          active: true,
        },
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2
      },
      httpAguarde:false,
      httpSenVerifica: false,
      httpSend: false,
      filtro: {
        pagina: 1,
        dam_codigo: "",
        pes_nome: "",
        eco_nome_fantasia: "",
        pes_cpfcnpj: "",
        tab_106situacao: ""
      },
      list_duam: [],
      duam_baixa_manual: {},
      duam_atualizada: {
        dam_codigo: null
      },
    };
  },
  computed: {
    tipo_arrecadacao: {
      get: function () {
        return parseInt(this.$store.state.auth.currentEntidade.par_tipo_cobranca);
      },
    },
  },
  created() {
    this.listDuams();
  },
  methods: {
    listDuams() {
      this.httpSend = true;
      listDuamsEmitidas(this.filtro).then(result => {
        this.list_duam = result.dados
      }).catch(error => {
        notifyErro("Erro de Servidor", error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    guiaDetalhe(guia) {
      this.$router.push({
        name: "contribuinte-financeiro-guia-detalhe",
        params: {dam_hash: guia.dam_hash}
      })
    },
    pagamento(guia) {
      this.$router.push({
        name: "contribuinte-financeiro-pagamento",
        params: {dam_hash: guia.dam_hash}
      })
    },
    verificarVencimento() {
      if (!this.duam_baixa_manual.novo_vencimento) {
        notifyAviso("Atenção", "Verifique a nova data de vencimento")
        return
      }
      this.httpSenVerifica = true;
      this.duam_atualizada = {dam_codigo: null};
      verificaAlteracaoVencimento(this.duam_baixa_manual.dam_codigo, this.duam_baixa_manual.novo_vencimento).then(response => {
        if (response.status) {
          this.duam_atualizada = response.dados;
        } else {
          notifyErro("DattaNFSe", response.mensagem)
        }
      }).catch(error => {
        notifyErro("Erro de Servidor", error)
      }).finally(() => {
        this.httpSenVerifica = false;
      })
    },
    realizarAlteracaoVencimento() {
      if (!this.duam_baixa_manual.novo_vencimento) {
        notifyAviso("Atenção", "Verifique a nova data de vencimento")
        return
      }
      this.httpAguarde = true;
      const dados = {
        dam_codigo: this.duam_baixa_manual.dam_codigo,
        dam_data_venc_atu: this.duam_baixa_manual.novo_vencimento
      }
      alteracaoVencimentoDuam(dados).then(response => {
        if (response.status) {
          notifySucesso("DattaNFSe", response.mensagem)
          this.listDuams();
          this.hideModalAlterarVencimento();
        } else {
          notifyErro("Atenção", response.mensagem)
        }
      }).catch(error => {
        notifyErro("Erro de Servidor", error)
      }).finally(() => {
        this.httpAguarde = false;
      })
    },
    showModalbaixaManualConfirmacao() {
      if (!this.duam_baixa_manual.bab_data_credbanco) {
        notifyAviso("Atenção", "Verifique a Data do Crédito")
        return
      }
      if (this.duam_baixa_manual.bab_valor_pago <= 0) {
        notifyAviso("Atenção", "Valor pago deve ser maior que zero")
        return
      }
      this.$modal.show('modal-baixa-manual-confirmacao');
    },
    showModalbaixaManual(duam) {
      this.duam_baixa_manual = duam;
      this.$modal.show('modal-baixa-manual');
    },
    hideModalBaixaManual() {
      this.$modal.hide('modal-baixa-manual');
      this.duam_baixa_manual = {};
    },
    hideModalBaixaManualConfirmacao() {
      this.$modal.hide('modal-baixa-manual-confirmacao');
    },
    showModalAlterarVencimento(duam) {
      this.duam_baixa_manual = duam;
      this.$modal.show('modal-alterar-vencimento');
    },
    hideModalAlterarVencimento() {
      this.$modal.hide('modal-alterar-vencimento');
      this.duam_baixa_manual = {};
      this.duam_atualizada = {dam_codigo: null};
    },
    baixaManual() {
      this.httpAguarde = true;
      duamBaixaManual(this.duam_baixa_manual).then(result => {
        if (result.status) {
          this.listDuams();
          notifySucesso("DattaNFSe", result.mensagem)
          this.hideModalBaixaManualConfirmacao();
          this.hideModalBaixaManual();
        } else {
          notifyErro("Erro ao Baixar Duam", result.mensagem)
          this.hideModalBaixaManualConfirmacao();
        }
      }).catch(error => {
        notifyErro("Erro de Servidor", error)
        console.log(error)
      }).finally(() => {
        this.httpAguarde = false
      })
    },
    printGuia(guia) {
      this.httpSend = true;
      impressao(getFinanceiroGuia(guia.dam_hash), 'P').catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    printComprovante(guia) {
      this.httpSend = true;
      impressao(getFinanceiroComprovante(guia.dam_hash), 'P').catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    }
  }
};
</script>


